export const VERIF_TOKEN = 'VerifToken';